import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { WidgetStore } from "./types";
import { createUISlice } from "./slices/uiSlice";
import { createConnectionSlice } from "./slices/connectionSlice";
import { createConversationSlice } from "./slices/conversationSlice";
import { createQuotaSlice } from "./slices/quotaSlice";
import { createConfigSlice } from "./slices/configSlice";
import { createErrorSlice } from "./slices/errorSlice";

// Create store with all slices combined
export const useWidgetStore = create<WidgetStore>()(
  devtools(
    (...args) => ({
      ...createUISlice(...args),
      ...createConnectionSlice(...args),
      ...createConversationSlice(...args),
      ...createQuotaSlice(...args),
      ...createConfigSlice(...args),
      ...createErrorSlice(...args),

      // Global reset function
      resetAll: () => {
        const [set, get] = args;
        // Zustand's `set` is not designed to be called inside another `set`.
        // Instead, we get the initial states from the slices and reset to them.
        // However, the provided user story has reset functions inside slices.
        // To follow the user story, we'll call them via `get()`.
        const state = get();
        state.resetUI();
        state.resetConnection();
        state.resetConversation();
        state.resetQuota();
        state.resetConfig();
        state.clearError();
      },
    }),
    {
      name: "remstal-widget-store",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);

// Export types
export * from "./types";

// Export selectors
export * from "./selectors";
